import React, { useState, Component } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const MIKE_PHONE = '+18183819905';
export function LiveChat() {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const sendToPhone = () => {
    const trimmed = message.trim();
    if (!trimmed) return;
    window.location.href = `sms:${MIKE_PHONE}?&body=${encodeURIComponent(trimmed)}`;
    setMessage('');
  };
  return <div className="fixed bottom-6 right-6 z-50" data-id="element-214">
      <AnimatePresence data-id="element-215">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} className="absolute bottom-20 right-0 w-80 bg-[#111118] border border-white/10 rounded-2xl shadow-2xl overflow-hidden flex flex-col" data-id="element-216">
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-600 to-blue-500 p-4 flex items-center justify-between" data-id="element-217">
              <div className="flex items-center gap-3" data-id="element-218">
                <div className="relative" data-id="element-219">
                  
                  <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-blue-600 rounded-full" data-id="element-220"></div>
                </div>
                <div data-id="element-221">
                  <h4 className="text-white font-bold text-sm" data-id="element-222">
                    Chat with Mike
                  </h4>
                  <p className="text-white/80 text-xs" data-id="element-223">
                    Typically replies in minutes
                  </p>
                </div>
              </div>
              <button onClick={() => setIsOpen(false)} className="text-white/80 hover:text-white transition-colors" data-id="element-224">
                <X size={20} data-id="element-225" />
              </button>
            </div>

            {/* Body */}
            <div className="h-64 bg-black p-4 flex flex-col gap-3 overflow-y-auto" data-id="element-226">
              <div className="bg-[#111118] border border-white/5 text-slate-300 p-3 rounded-2xl rounded-tl-sm text-sm self-start max-w-[85%] shadow-sm" data-id="element-227">
                Hi there! 👋 I'm Mike. Type a message below and it'll text me
                directly at (818) 381-9905 — I typically reply in minutes.
              </div>
            </div>

            {/* Input */}
            <div className="p-3 bg-[#111118] border-t border-white/5 flex gap-2" data-id="element-228">
              <input type="text" value={message} onChange={e => setMessage(e.target.value)} onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              sendToPhone();
            }
          }} placeholder="Type your message..." className="flex-1 bg-black border border-white/10 rounded-full px-4 py-2 text-sm text-white focus:outline-none focus:border-blue-500" data-id="element-229" />
              <button onClick={sendToPhone} disabled={!message.trim()} aria-label="Send message via text" className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white hover:bg-blue-700 transition-colors flex-shrink-0 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-230">
                <Send size={16} className="ml-1" data-id="element-231" />
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>

      <button onClick={() => setIsOpen(!isOpen)} className="w-14 h-14 rounded-full bg-gradient-to-r from-blue-600 to-blue-500 text-white flex items-center justify-center shadow-[0_0_20px_rgba(59,130,246,0.3)] hover:scale-110 transition-transform" data-id="element-232">
        {isOpen ? <X size={24} data-id="element-233" /> : <MessageCircle size={24} data-id="element-234" />}
      </button>
    </div>;
}